export default "__VITE_ASSET__848d4110__"